import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, userPrefPageSize } from '@/decorators';

var SystemLogInboundOrderPage = function (_super) {
  __extends(SystemLogInboundOrderPage, _super);

  function SystemLogInboundOrderPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.columns = [];
    _this.loadingStatus = false;
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition();
    _this.searchData = _this.getInitSearchData();
    _this.lastParams = {};
    _this.total = 0;
    return _this;
  }

  SystemLogInboundOrderPage.prototype.onDatetimeDefaultValueChange = function (arr) {
    if (arr.length) {
      this.searchData.start_time = this.$util.formatDateTime(arr[0]);
      this.searchData.end_time = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.start_time = '';
      this.searchData.end_time = '';
    }
  };

  SystemLogInboundOrderPage.prototype.created = function () {
    this.columns = [{
      title: this.t('入库单号'),
      dataIndex: 'receiving_code',
      filterEmpty: true
    }, {
      title: this.t('操作人'),
      dataIndex: 'user_name',
      filterEmpty: true
    }, {
      title: this.t('日志'),
      scopedSlots: {
        customRender: 'rl_content'
      }
    }, {
      title: this.t('日志时间'),
      dataIndex: 'rl_add_time',
      filterEmpty: true
    }];
    this.queryInboundOrderLogList();
  };

  SystemLogInboundOrderPage.prototype.queryInboundOrderLogList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, list, total;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.lastParams = this.$util.deepCopy(this.searchData);
            return [4, this.$api.assistant.queryInboundOrderLogList(this.searchData)];

          case 1:
            data = _a.sent().data;
            list = data.list, total = data.total;
            this.dataList = this.$util.createTableRowKey(list);
            this.total = total;
            return [2];
        }
      });
    });
  };

  SystemLogInboundOrderPage.prototype.getInitSearchData = function () {
    return {
      page_index: 1,
      page_size: 10,
      code_field: 'receiving_code',
      code_value: '',
      start_time: '',
      end_time: ''
    };
  };

  SystemLogInboundOrderPage.prototype.handlePageChange = function (val) {
    this.initPage();
    this.searchData.page_index = val;
    this.queryInboundOrderLogList();
  };

  SystemLogInboundOrderPage.prototype.handleTabChange = function (key) {
    this.initPage();
    this.queryInboundOrderLogList();
  };

  SystemLogInboundOrderPage.prototype.initPage = function () {
    this.searchData.page_index = 1;
  };

  SystemLogInboundOrderPage.prototype.handleSearch = function () {
    this.initPage();
    this.queryInboundOrderLogList();
  };

  SystemLogInboundOrderPage.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.getInitSearchData();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
    this.$nextTick(function () {
      return _this.queryInboundOrderLogList();
    });
  };

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], SystemLogInboundOrderPage.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([loading('loadingStatus')], SystemLogInboundOrderPage.prototype, "queryInboundOrderLogList", null);

  __decorate([userPrefPageSize('systemLogInboundOrderList')], SystemLogInboundOrderPage.prototype, "getInitSearchData", null);

  SystemLogInboundOrderPage = __decorate([Component], SystemLogInboundOrderPage);
  return SystemLogInboundOrderPage;
}(Vue);

export default SystemLogInboundOrderPage;